$(document).ready(function () {
  let topSlickSlider = $(
    ".section-fcsg_tv .collage-slider:not(.slick-initialized)"
  ).slick({
    dots: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev"><i class="icon-arrow"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next"><i class="icon-arrow"></i></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 8000,
    speed: 500,
    // draggable: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          // arrows: false,
          // dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Register ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);

  gsap.config({ nullTargetWarn: false });

  // initializeAnimation();
  // Function to initialize GSAP animations
  function initializeAnimation() {
    // Kill all existing ScrollTriggers to avoid duplicates
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

    const $box = $(".fcsg_tv_section .collage__item");
    let $titleHeight = $(".fcsg_tv_section .collage-wrapper-title");
    let titleYheight = $titleHeight.height();
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    // Get box's original dimensions
    let boxWidth = $box.width();
    let boxHeight = $box.height();
    let startScaleX = windowWidth / boxWidth;
    let startScaleY = windowHeight / boxHeight;
    let reverScaleY = boxHeight / windowHeight;
    let reverScaleX = boxWidth / windowWidth;
    let translateX = (boxWidth * startScaleX - boxWidth) / 2; // Adjust translation
    let imgScaleX = boxWidth / windowWidth;
    let imgScaleY = startScaleY + 0.1;
    let topStatpoint = 85; // Correctly define topStatpoint as a number, not `84px`
    // let startScale = scaleY;
    // let endScale = scaleY;
    let mobileHeight = 50;
    let textHeight = boxHeight - titleYheight - 85;
    let starttextHeight = boxHeight - titleYheight - 85 - 24;
    let deskDelay1 = 0.3;
    let deskDelay2 = 0.2;

    let titleSize = 0.7;
    let fontSizeh2 = 2;
    let lineHeighth2 = 2;
    let fontSizeh3 = 2;
    let lineHeighth3 = 2;
    let mobilekDelay = 0;
    if ($(window).width() <= 1680) {
      topStatpoint = 70;
    }
    if ($(window).width() <= 749) {
      topStatpoint = 0;
      deskDelay1 = 0.6;
      deskDelay2 = 0.3;
      titleSize = imgScaleX - 0.1;
      fontSizeh2 = 2;
      lineHeighth2 = 2;
      startScaleX = windowWidth / boxWidth;
      startScaleY = windowHeight / boxHeight + 0.2;
      let mobilekDelay = 1;
      // duration = 1.3;
      // textHeight = boxHeight * 2;
      // startScale = 2;
      // endScale = 1.7777;
    }
    if (startScaleX > startScaleY) {
      startScaleY = startScaleX;
      reverScaleY = reverScaleX;
    } else {
      startScaleX = startScaleY;
      reverScaleX = reverScaleY;
    }
    // Define the animation timeline
    let timeline = gsap.timeline({
      scrollTrigger: {
        trigger: ".fcsg_tv_section",
        start: `top ${topStatpoint}px`, // Dynamically insert the value
        end: "bottom+=50%", // Total animation range (2x viewport height for the full animation)
        // end: () => `+=${windowHeight}`, // Scroll range matches viewport height
        scrub: true, // Smooth animation tied to scroll
        pin: ".fcsg_tv_section", // Pin the section during animation
        anticipatePin: 1,
        markers: false, // Enable for debugging
      },
    });

    // First scale transition: 4.3333 to 3.3333 over 100vh
    timeline
      .addLabel("start") // Add a label to sync animations
      .fromTo(
        ".fcsg_tv_section .slick-current",
        { scaleX: startScaleX, scaleY: startScaleY, delay: mobilekDelay }, // Starting scale

        {
          scaleX: startScaleX,
          scaleY: startScaleY, // Intermediate scale
          duration: 1,
          // delay: mobilekDelay,
          ease: "power1.out",
        },
        "start" // Start this animation at the "start" label
      )
      .fromTo(
        ".fcsg_tv_section .slick-current .img_wrap",
        {
          scaleX: 1.2,
          scaleY: 1.2,
        }, // Starting scale

        {
          scaleX: 1,
          scaleY: 1, // Intermediate scale
          duration: 1,
          ease: "power1.out",
        },
        "start" // Start this animation at the "start" label
      )
      .fromTo(
        ".fcsg_tv_section .slick-current .media a",
        {
          y: "200px",
          // scaleX: reverScaleX,
          // scaleY: reverScaleX,
          scaleX: titleSize,
          scaleY: titleSize,
          // x:translateX,
          duration: 1,
          delay: deskDelay1,
        }, // Starting position
        {
          y: "-30px", // Intermediate position
          scaleX: titleSize,
          scaleY: titleSize,
          duration: 1.3,
          delay: deskDelay2,
          ease: "power1.out",
          // x:"0%",
        },
        "start" // Start this animation at the "start" label
      )
      .fromTo(
        ".fcsg_tv_section .slick-current .media .video-heading",
        {
          fontSize: `${fontSizeh2}rem`,
          lineHeight: `${lineHeighth2}rem`,

          duration: 1,
          delay: deskDelay1,
        }, // Starting position
        {
          fontSize: `${fontSizeh2}rem`,
          lineHeight: `${lineHeighth2}rem`,
          duration: 1.3,
          delay: deskDelay2,
          ease: "power1.out",
          // x:"0%",
        },
        "start" // Start this animation at the "start" label
      );

    // Second scale transition: 3.3333 to 1 over the next 100vh
    timeline
      .addLabel("secondPhase", "+=0.2") // Add another label with a slight delay
      .fromTo(
        ".fcsg_tv_section .slick-current",
        { scaleX: startScaleX, scaleY: startScaleY }, // Starting scale
        {
          scaleX: 1,
          scaleY: 1, // Final scale
          duration: 0.7,
          ease: "power2.out",
          onUpdate: function () {
            // Get the current scale of the slick-current slide
            const currentScale = gsap.getProperty(
              ".fcsg_tv_section .slick-current",
              "scale"
            );

            // Toggle opacity of non-current slides and other elements based on scale
            if (currentScale <= 1.00000000001) {
              gsap.to(
                ".fcsg_tv_section .slick-slide:not(.slick-current), .fcsg_tv_section .collage-wrapper-title, .fcsg_tv_section .button_wrap, .fcsg_tv_section .slick-arrow, .fcsg_tv_section .slick-slide",
                {
                  autoAlpha: 1, // Make other slides visible
                  duration: 0.5,
                  ease: "power1.inOut",
                  scale: 1,
                  onComplete: () => {
                    gsap.utils
                      .toArray(".section-fcsg_tv")
                      .forEach((el) => el.classList.add("animated_div"));
                  },
                  onReverseComplete: () => {
                    gsap.utils
                      .toArray(".section-fcsg_tv")
                      .forEach((el) => el.classList.remove("animated_div"));
                  },
                }
              );
            } else {
              gsap.to(
                ".fcsg_tv_section .slick-slide:not(.slick-current), .fcsg_tv_section .collage-wrapper-title, .fcsg_tv_section .button_wrap, .fcsg_tv_section .slick-arrow",
                {
                  autoAlpha: 0, // Hide other slides
                  duration: 0.5,
                  ease: "power1.inOut",
                  onComplete: () => {
                    gsap.utils
                      .toArray(".section-fcsg_tv")
                      .forEach((el) => el.classList.remove("animated_div"));
                  },
                  onReverseComplete: () => {
                    gsap.utils
                      .toArray(".section-fcsg_tv")
                      .forEach((el) => el.classList.remove("animated_div"));
                  },
                }
              );
            }
          },
        },
        "secondPhase" // Start this animation at the "secondPhase" label
      )

      .fromTo(
        ".fcsg_tv_section .slick-current .media a",
        {
          y: "-30px",
          scaleX: titleSize,
          scaleY: titleSize,
          duration: 0.7,
          // delay: deskDelay1,
        }, // Starting position
        {
          y: "0px",
          scaleX: 1,
          scaleY: 1,
          duration: 0.7,
          ease: "power2.out",
        },
        "secondPhase" // Start this animation at the "secondPhase" label
      )
      .fromTo(
        ".fcsg_tv_section .slick-current .media .video-heading",
        {
          fontSize: `${fontSizeh3}rem`,
          lineHeight: `${lineHeighth3}rem`,
          duration: 0.7,
          // delay: deskDelay1,
        }, // Starting position
        {
          fontSize: `${fontSizeh3}rem`,
          lineHeight: `${lineHeighth3}rem`,
          duration: 0.7,
          ease: "power2.out",
        },
        "secondPhase" // Start this animation at the "secondPhase" label
      );
  }
  // ScrollTrigger to detect when `fcsg_tv_wrapper` hits the top
  ScrollTrigger.create({
    trigger: ".fcsg_tv_wrapper",
    start: "top 100%", // Trigger when `fcsg_tv_wrapper` reaches the top of the viewport
    onEnter: () => {
      initializeAnimation(); // Reinitialize animations
    },
    onEnterBack: () => {
      initializeAnimation(); // Reinitialize animations on scroll back up
    },
  });
  initializeAnimation();
  delayAnimation();
  function delayAnimation() {
    // Reinitialize GSAP animations after slide change
    setTimeout(() => {
      initializeAnimation();
    }, 550); // Slight delay to ensure Slick has updated
  }

  // Ensure animations are initialized after the window is fully loaded
  $(window).on("load", function () {
    $(".fcsg_tv_section").removeClass("default-hide-section");
    // Initialize GSAP animations on page load
    initializeAnimation();
  });

  $(".fcsg_tv_section .slick-arrow").on("click", function () {
    $(this).prop("disabled", true);
    $(".section-fcsg_tv").addClass("animated_col");

    delayAnimation();
  });

  // Listen for Slick slider changes (e.g., swipe, autoplay)
  $(".fcsg_tv_section .slick-slider").on("afterChange", function () {
    $(this).prop("disabled", true);
    $(".section-fcsg_tv").addClass("animated_col");
    delayAnimation();
  });

  $(window).on("scroll", () => {
    setTimeout(() => {
      $(".section-fcsg_tv").removeClass("animated_col");
    }, 800);
  });

  function destroySlickslider() {
    if ($(".section-fcsg_tv .collage-slider").hasClass("slick-initialized")) {
      topSlickSlider.slick("destroy");
    }
  }
  function tvSlickslider() {
    topSlickSlider.slick("refresh");
  }

  subscribe("feed-loaded", (e) => {
    // console.log("🚩", e);
    destroySlickslider();
    tvSlickslider();
    delayAnimation();
    initializeSwiper();
    fcsgtvsectionHeights();
  });

  function initializeSwiper() {
    let marqueeSlider = document.querySelector(".swiper-wrapperss");
    let mainTicker = new Flickity(".swiper-wrapperss", {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
      adaptiveHeight: true,
    });

    // Initial position
    mainTicker.x = 0;
    let requestId;
    let speed = 0.6; // Normal speed
    let isHovering = false; // Track hover state

    // Start the marquee animation
    play();

    // Main function that 'plays' the marquee.
    function play() {
      // Adjust speed based on hover state
      const currentSpeed = isHovering ? 0.15 : speed;

      // Update the position
      mainTicker.x -= currentSpeed;

      // Settle position into the slider
      mainTicker.settle(mainTicker.x);

      // Continue the animation loop
      requestId = window.requestAnimationFrame(play);
    }

    // Function to handle hover
    function onHover() {
      isHovering = true; // Set hover state to true
    }

    // Function to handle hover out
    function onHoverOut() {
      isHovering = false; // Reset hover state
    }

    // Add event listeners for hover
    marqueeSlider.addEventListener("mouseenter", onHover);
    marqueeSlider.addEventListener("mouseleave", onHoverOut);
  }

  /* end */

  fcsgtvsectionHeights();
  function heightDelay() {
    // Reinitialize GSAP animations after slide change
    setTimeout(() => {
      fcsgtvsectionHeights();
    }, 0); // Slight delay to ensure Slick has updated
  }
  function fcsgtvsectionHeights() {
    const mainSection = $(".fcsg_tv_section");
    const pageDiv = $(".fcsg_tv_section").find(".page-width");
    const fcsgHeight = mainSection.outerHeight();
    const fcsgDiv = pageDiv.outerHeight();
    const totleHeight = fcsgHeight - fcsgDiv;
    // console.log("height", pinpacerHeight);
    $(".collage-wrapper").css("margin-top", -totleHeight);
  }
});
